jQuery(document).ready(function ($)
{
	const $el = $('[data-scroll-text]');

	// split into letters
	const text = $el.text();
	$el.empty();

	const letters = text.split("").map(function(char)
	{
		const $span = $('<span>').text(char);
		$el.append($span);
		return $span;
	});

	$(window).on('scroll', function()
	{
		const rect = $el[0].getBoundingClientRect();
		const windowHeight = window.innerHeight;

		const progress = Math.min(
			Math.max((windowHeight - rect.top) / windowHeight, 0),
			1
		);

		const total = letters.length;

		$.each(letters, function(i, $span)
		{
			// each letter gets its own slice of the timeline
			const letterProgress = progress * total - i;

			// clamp 0–1
			const p = Math.min(Math.max(letterProgress, 0), 1);

			// interpolate color
			const r = Math.round(160 + (37 - 160) * p);
			const g = Math.round(163 + (39 - 163) * p);
			const b = Math.round(182 + (56 - 182) * p);

			$span.css('color', `rgb(${r}, ${g}, ${b})`);
		});
	});
});
